import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateScheduleRequests = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 158,
	viewBox: "0 0 200 158",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6783_33192)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M816.128 -151.854H-116.862V372.953H816.128V-151.854Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M90.6456 157.928C134.256 157.928 169.61 122.575 169.61 78.964C169.61 35.3534 134.256 0 90.6456 0C47.035 0 11.6816 35.3534 11.6816 78.964C11.6816 122.575 47.035 157.928 90.6456 157.928Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M84.7808 51.052L135.313 51.052C142.277 51.052 147.923 45.4063 147.923 38.4421V25.0789C147.923 18.1146 142.277 12.469 135.313 12.469L84.7808 12.469C77.8165 12.469 72.1709 18.1146 72.1709 25.0789V38.4421C72.1709 45.4063 77.8165 51.052 84.7808 51.052Z",
				fill: "#C2F4F1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M123.567 50.4835C118.83 58.3605 110.914 60.2216 106.803 60.6395C105.909 60.7318 105.384 59.6531 106.011 59.0068C108.907 56.0037 110.17 53.0347 110.617 50.4835H123.572H123.567Z",
				fill: "#C2F4F1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.3033 55.9406H37.587C31.6855 55.9406 26.9014 60.7247 26.9014 66.6262V72.2727C26.9014 78.1743 31.6855 82.9584 37.587 82.9584H59.3033C65.2049 82.9584 69.989 78.1743 69.989 72.2727V66.6262C69.989 60.7247 65.2049 55.9406 59.3033 55.9406Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.53759 60.6832C5.49134 60.6832 7.07517 59.0994 7.07517 57.1456C7.07517 55.1919 5.49134 53.608 3.53759 53.608C1.58383 53.608 0 55.1919 0 57.1456C0 59.0994 1.58383 60.6832 3.53759 60.6832Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M166.806 22.5327C169.184 22.5327 171.112 20.6051 171.112 18.2274C171.112 15.8496 169.184 13.922 166.806 13.922C164.429 13.922 162.501 15.8496 162.501 18.2274C162.501 20.6051 164.429 22.5327 166.806 22.5327Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M175.879 46.7661C177.239 46.7661 178.342 45.6631 178.342 44.3024C178.342 42.9418 177.239 41.8387 175.879 41.8387C174.518 41.8387 173.415 42.9418 173.415 44.3024C173.415 45.6631 174.518 46.7661 175.879 46.7661Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.2891 82.5114C44.3796 87.6525 49.5451 88.8625 52.2274 89.1395C52.8105 89.1978 53.1555 88.498 52.7473 88.0753C50.8571 86.117 50.0358 84.1781 49.7443 82.5162H41.2939L41.2891 82.5114Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131.586 120.647V128.568H124.885",
				stroke: "#3F8BFD",
				strokeWidth: 3.88746,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M112.804 120.647V128.568H106.099",
				stroke: "#3F8BFD",
				strokeWidth: 3.88746,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M126.294 99.6113C122.241 103.664 115.676 103.664 111.623 99.6113C107.571 95.5586 107.571 88.9936 111.623 84.941C115.676 80.8883 149.769 61.4656 149.769 61.4656C149.769 61.4656 130.346 95.5586 126.294 99.6113Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 3.88746,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.77 61.4656L164.289 127.859H172.589",
				stroke: "#3F8BFD",
				strokeWidth: 3.88746,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.54 120.336H101.551V77.545H181.331C181.331 101.176 162.171 120.336 138.54 120.336Z",
				fill: "#9EC5FF",
				stroke: "#9EC5FF",
				strokeWidth: 2.87672,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M92.1568 77.545H101.555V120.336C89.7368 120.336 80.1396 110.739 80.1396 98.9212V89.5621C80.1396 82.9292 85.5238 77.545 92.1568 77.545Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M101.55 121.775C88.93 121.775 78.6963 111.541 78.6963 98.9212V89.5622C78.6963 82.1323 84.7219 76.1067 92.1518 76.1067H102.988V120.336C102.988 121.133 102.342 121.775 101.55 121.775Z",
				fill: "#C5DCFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M117.824 77.4771H198.557C198.557 89.3241 188.94 98.9407 177.093 98.9407H139.288C127.441 98.9407 117.824 89.3241 117.824 77.4771Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.093 100.384H139.288C126.639 100.384 116.386 90.1308 116.386 77.4819C116.386 76.685 117.032 76.0436 117.824 76.0436H198.557C199.354 76.0436 199.995 76.6899 199.995 77.4819C199.995 90.1308 189.742 100.384 177.093 100.384ZM119.316 78.9203C120.055 89.295 128.733 97.5072 139.293 97.5072H177.098C187.657 97.5072 196.331 89.295 197.075 78.9203H119.321H119.316Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M99.4942 81.8602C99.4942 70.5963 90.3635 61.4705 79.1045 61.4705",
				stroke: "#C5DCFF",
				strokeWidth: 1.94373,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93.3281 82.0303C93.3281 75.2272 87.8128 69.7119 81.0098 69.7119",
				stroke: "#C5DCFF",
				strokeWidth: 1.94373,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M148.803 99.6113C144.75 103.664 138.185 103.664 134.132 99.6113C130.08 95.5586 130.08 88.9936 134.132 84.941C138.185 80.8883 172.278 61.4656 172.278 61.4656C172.278 61.4656 152.855 95.5586 148.803 99.6113Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 3.88746,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.277 61.4656L186.802 127.859H195.102",
				stroke: "#3F8BFD",
				strokeWidth: 3.88746,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.2959 125.03V129.268H45.8869",
				stroke: "#3F8BFD",
				strokeWidth: 1.89028,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.4199 125.03V129.268H54.0061",
				stroke: "#3F8BFD",
				strokeWidth: 1.89028,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.199 113.771C45.3663 115.939 48.8796 115.939 51.0517 113.771C53.219 111.604 53.219 108.091 51.0517 105.919C48.8845 103.751 30.6377 93.3573 30.6377 93.3573C30.6377 93.3573 41.0318 111.599 43.199 113.771Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 1.89028,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.6382 93.3622L22.8682 128.889H18.4268",
				stroke: "#3F8BFD",
				strokeWidth: 1.89028,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.6491 124.86H56.4411V101.963H13.752C13.752 114.607 24.0051 124.86 36.6491 124.86Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.2139 125.633H36.6493C23.5971 125.633 12.9795 115.015 12.9795 101.963V101.195H57.209V125.633H57.2139Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M56.4411 124.86V101.963H61.4705C65.0178 101.963 67.8994 104.845 67.8994 108.392V113.402C67.8994 119.724 62.7631 124.86 56.4411 124.86Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M56.4416 125.633C63.1961 125.633 68.6725 120.156 68.6725 113.402V108.392C68.6725 104.417 65.4508 101.191 61.471 101.191H55.6738V124.86C55.6738 125.288 56.0188 125.628 56.4416 125.628V125.633Z",
				fill: "#C5DCFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.246 113.417H16.0166C9.67519 113.417 4.52916 108.271 4.52916 101.929H47.7334C47.7334 108.271 42.5874 113.417 36.246 113.417Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.016 114.184H36.2453C43.0144 114.184 48.5005 108.698 48.5005 101.929C48.5005 101.502 48.1555 101.161 47.7328 101.161H4.52852C4.10089 101.161 3.76074 101.506 3.76074 101.929C3.76074 108.698 9.24692 114.184 16.016 114.184Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.5391 104.271C57.5391 98.2458 62.4227 93.3573 68.4531 93.3573",
				stroke: "#C5DCFF",
				strokeWidth: 1.18082,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.8438 104.364C60.8438 100.724 63.7934 97.7695 67.4379 97.7695",
				stroke: "#C5DCFF",
				strokeWidth: 1.18082,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.158 113.771C33.3253 115.939 36.8386 115.939 39.0107 113.771C41.178 111.604 41.178 108.091 39.0107 105.919C36.8434 103.751 18.5967 93.3573 18.5967 93.3573C18.5967 93.3573 28.9908 111.599 31.158 113.771Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 1.89028,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.5962 93.3622L10.8213 128.889H6.37988",
				stroke: "#3F8BFD",
				strokeWidth: 1.89028,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.7533 131.304H67.2289C67.6323 131.304 67.9578 130.978 67.9578 130.575C67.9578 130.172 67.6323 129.846 67.2289 129.846H38.7533C38.35 129.846 38.0244 130.172 38.0244 130.575C38.0244 130.978 38.35 131.304 38.7533 131.304Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.058 131.304H56.5336C56.937 131.304 57.2625 130.978 57.2625 130.575C57.2625 130.172 56.937 129.846 56.5336 129.846H28.058C27.6547 129.846 27.3291 130.172 27.3291 130.575C27.3291 130.978 27.6547 131.304 28.058 131.304Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.13027 131.304H20.443C20.8463 131.304 21.1719 130.978 21.1719 130.575C21.1719 130.172 20.8463 129.846 20.443 129.846H4.13027C3.72694 129.846 3.40137 130.172 3.40137 130.575C3.40137 130.978 3.72694 131.304 4.13027 131.304Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M176.602 131.304H192.915C193.318 131.304 193.644 130.978 193.644 130.575C193.644 130.172 193.318 129.846 192.915 129.846H176.602C176.199 129.846 175.873 130.172 175.873 130.575C175.873 130.978 176.199 131.304 176.602 131.304Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M154.094 131.304H170.407C170.81 131.304 171.136 130.978 171.136 130.575C171.136 130.172 170.81 129.846 170.407 129.846H154.094C153.691 129.846 153.365 130.172 153.365 130.575C153.365 130.978 153.691 131.304 154.094 131.304Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M74.7221 131.304H158.895C159.299 131.304 159.624 130.978 159.624 130.575C159.624 130.172 159.299 129.846 158.895 129.846H74.7221C74.3187 129.846 73.9932 130.172 73.9932 130.575C73.9932 130.978 74.3187 131.304 74.7221 131.304Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M85.4167 85.3928C85.0717 85.3928 84.7947 85.6747 84.7996 86.0148C84.7996 86.355 84.5226 86.6368 84.1825 86.6368C84.0027 86.6271 83.8617 86.5736 83.7403 86.457C83.6236 86.3404 83.5556 86.1849 83.5556 86.0197C83.5556 85.6795 83.2738 85.4025 82.9336 85.4025C82.5886 85.4025 82.3116 85.6844 82.3165 86.0245C82.3165 86.525 82.5157 86.9915 82.8656 87.3414C83.2154 87.6913 83.6819 87.8808 84.1776 87.8808H84.1873C85.2126 87.8808 86.0484 87.0353 86.0436 86.01C86.0436 85.6698 85.7617 85.3928 85.4216 85.3928H85.4167Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.7371 85.3928C94.392 85.3928 94.1151 85.6747 94.1199 86.0148C94.1199 86.355 93.8429 86.6368 93.5028 86.6368C93.3376 86.6368 93.1821 86.5736 93.0655 86.457C92.9488 86.3404 92.8808 86.1849 92.8808 86.0197C92.8808 85.6795 92.599 85.4025 92.2588 85.4025C91.9138 85.4025 91.6368 85.6844 91.6417 86.0245C91.6417 86.525 91.8409 86.9915 92.1908 87.3414C92.5406 87.6913 93.0071 87.8808 93.5028 87.8808H93.5125C94.5427 87.8808 95.3736 87.0353 95.3688 86.01C95.3688 85.6698 95.0869 85.3928 94.7468 85.3928H94.7371Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.9435 93.6975H85.7284C85.3834 93.6975 85.1064 93.4205 85.1064 93.0755C85.1064 92.7305 85.3834 92.4535 85.7284 92.4535H91.9435C92.2885 92.4535 92.5655 92.7305 92.5655 93.0755C92.5655 93.4205 92.2885 93.6975 91.9435 93.6975Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5512 106.074C59.5512 105.656 59.2159 105.311 58.7932 105.311C58.3753 105.311 58.0303 105.647 58.0303 106.069C58.0303 106.487 58.3656 106.832 58.7883 106.832C59.2062 106.832 59.5512 106.497 59.5512 106.074Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M65.2514 106.074C65.2514 105.656 64.9161 105.311 64.4934 105.311C64.0755 105.311 63.7305 105.647 63.7305 106.069C63.7305 106.487 64.0658 106.832 64.4885 106.832C64.9064 106.832 65.2514 106.497 65.2514 106.074Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.5208 109.685H59.7159C59.507 109.685 59.3369 109.515 59.3369 109.306C59.3369 109.097 59.507 108.927 59.7159 108.927H63.5208C63.7297 108.927 63.8998 109.097 63.8998 109.306C63.8998 109.515 63.7297 109.685 63.5208 109.685Z",
				fill: "#6BA6FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6783_33192",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 157.928,
			fill: "white"
		})
	}) })]
});
export default SvgEmptyStateScheduleRequests;
